// src/views/letters/components/ImageChoice.tsx
// Kopia src/views/kiddo-games/letters/components/ImageChoice.tsx — tylko dla Literuj Regular
import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import classes from '../LettersView.module.less';

interface ImageChoiceProps {
  image: string;
  isWrong: boolean;
  isSelected?: boolean;
  onClick: () => void;
}

export const ImageChoice: FC<ImageChoiceProps> = memo(({
  image, isWrong, isSelected, onClick,
}) => {
  const { t } = useTranslation();
  const className = `${classes.imageChoice}${isWrong ? ` ${classes.imageChoiceWrong}` : ''}${
    isSelected ? ` ${classes.imageChoiceCorrect}` : ''
  }`;

  return (
    <div
      className={className}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
    >
      <img src={image} alt={t('games:labels.choose')} />
    </div>
  );
});
